import script from "./SitemapBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./SitemapBlock.vue?vue&type=script&setup=true&lang=ts"

import "./SitemapBlock.vue?vue&type=style&index=0&id=3ba24468&lang=scss"

const __exports__ = script;

export default __exports__